const ErrorTypes = {
    NO_VEHICLE_AVAILABLE: 'NO_VEHICLE_AVAILABLE',
    INVALID_PROMOCODE: 'INVALID_PROMOCODE',
    NO_MISC_AVAILABLE: 'NO_MISC_AVAILABLE',
    NO_INVENTORY_AVAILABLE: 'NO_INVENTORY_AVAILABLE',
    NO_LOCATION_AVAILABLE:'NO_LOCATION_AVAILABLE'
}

export default ErrorTypes;
